export default __webpack_public_path__ + "static/media/obsbot_sponsor.487f4cda.png";